import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { cities } from 'src/app/shared/models/cities';
import { BankDetail } from 'src/app/shared/models/clients/bankDetail';
import { countries } from 'src/app/shared/models/countries';

@Component({
  selector: 'app-bank-details-modal',
  templateUrl: './bank-details-modal.component.html',
  styleUrls: ['./bank-details-modal.component.scss']
})
export class BankDetailsModalComponent implements OnInit {
  public bankDetails: BankDetail;
  public cities = cities;
  public countries = countries;
  public currencies;
  @ViewChild('bankModal') bankModal;
  @Output() submit: EventEmitter<BankDetail> = new EventEmitter<BankDetail>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: ClientsApiService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService) { }

  ngOnInit(): void {
    this.currencies = require('currencies.json').currencies;
  }

  // handle the popup
  open(bankDetails: BankDetail) {
    this.bankDetails = Object.assign(new BankDetail(), bankDetails);
    this.modalRef = this.modalService.open(this.bankModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    if (this.bankDetails.id) {
      this.spinner.show();
      this.api.updateClientBank(this.bankDetails.clientId, this.bankDetails).subscribe(
        n => {
          this.spinner.hide();
          this.submit.emit(n);
        }
      )
    } else {
      this.spinner.show();
      this.api.createClientBank(this.bankDetails.clientId, this.bankDetails).subscribe(
        n => {
          this.spinner.hide();
          this.submit.emit(n);
        }
      )
    }
  }

  currencySearchFn(currency) {
    return currency.code || currency.name;
  }

  searchFn() {
    return true;
  }
}
